import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem1 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Applied Physics-I', link: `/notes/${branch.toLowerCase()}/AppliedPhysicsI` },
    { title: 'Applied Mathematics-I', link: `/notes/${branch.toLowerCase()}/AppliedMathI` },
    { title: 'Applied Chemistry', link: `/notes/${branch.toLowerCase()}/AppliedChemistry` },
    { title: 'Communication Skills', link: `/notes/${branch.toLowerCase()}/CommunicationSkills` },
    { title: 'Engineering Mechanics', link: `/notes/${branch.toLowerCase()}/Engineering_Mechanics` },
    { title: 'Electrical Science', link: `/notes/${branch.toLowerCase()}/Electrical_Science` },
    { title: 'Enviromental Science', link: `/notes/${branch.toLowerCase()}/Enviromental_Studies` },
    { title: 'Human Values and Ethics', link: `/notes/${branch.toLowerCase()}/Human values and Ethics` },
    { title: 'Indian Constitution', link: `/notes/${branch.toLowerCase()}/Indian_Constitution` },
    { title: 'Manufacturing Process', link: `/notes/${branch.toLowerCase()}/Manufacturing_Process` },
    { title: 'Programming in C', link: `/notes/${branch.toLowerCase()}/Programming_In_C` },
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="1st Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem1;
